import React from 'react';
import './blItemCartDetails.scss';
import FormattedPrice from '../../components/FormattedPrice';
import {getItemPrice} from '../../helpers/common';

const BlItemCartDetails = ({blItems, t, branchInfo}) => {
  return (
    <div className={ 'bl-item-cart-details' }>
      {
        blItems.sort((a, b) => a.relation.restrictions.item_order - b.relation.restrictions.item_order).map((item, index) => (
          <div className={ 'lunch-item' }>
            <div className={ 'item-block' }>
              <div className={ 'item-name' }>
                {item.menuItem.item_name}
              </div>
              {item.orderItem.price > 0 && (
                <div className={ 'lunch-item-price' }>
                  <FormattedPrice price={ getItemPrice(item) } />
                </div>
              )}
            </div>
            <div className={ 'item-additions' }>
              <div className={ 'instructions' }>
                {item.instructions.map(i => i.menuItem.item_name).join(', ')}
              </div>
              <div className={ 'supplements' }>
                {
                  item.supplements.map((s, index) => (
                    <div className={ 'bl-item-supplement' }>
                      <div className={ 'supplement-name' }>
                        {s.menuItem.item_name}
                      </div>
                      <div className={ 'supplement-price' }>
                        <FormattedPrice price={ getItemPrice(s) } />
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        ))
      }
    </div>
  );
};

export default BlItemCartDetails;
